import { render, staticRenderFns } from "./uvList.vue?vue&type=template&id=93e75cfc&scoped=true"
import script from "./uvList.vue?vue&type=script&lang=js"
export * from "./uvList.vue?vue&type=script&lang=js"
import style0 from "./uvList.vue?vue&type=style&index=0&id=93e75cfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e75cfc",
  null
  
)

export default component.exports